export default "__VITE_ASSET__BQcuhoic__"